import React, { useEffect, useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import NotificationsIcon from "@material-ui/icons/Notifications";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import MailIcon from "@material-ui/icons/Mail";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";
import KpsEditor from "../editor/KpsEditor";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { stompClientsContainer} from "../../UniversalElement";
import moment from "moment";
import Badge from "@material-ui/core/Badge";
import Collapse from "@material-ui/core/Collapse";
import { useHistory } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import Skeleton from "@material-ui/lab/Skeleton";
import axios from "../../AxiosClient";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import { useSelector } from "react-redux";
import CreateMessage from "../messages/CreateMessage";
import { discussionClient, notificationClient } from "../../AxiosClient";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { red } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    zIndex: 9999999999999999999,
  },
  dismissIcon: {
    width: 24,
  },
  timeAgo: {
    color: theme.palette.grey[600],
    fontSize: "0.8em",
  },
  actionContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

function ItemNotification(props) {
  const classes = useStyles();
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [requiredReading, setRequiredReading] = useState(null);
  const [editMessage, setEditMessage] = useState(false);
  const [content, setContent] = useState(null);
  const history = useHistory();
  const [read, setRead] = useState(null);
  const { t } = useTranslation();
  const theme = useTheme();
  const [dialogOpen, setDialogOpen] = useState(false);
  const { currentUser } = useSelector((state) => ({
    currentUser: state.user.currentUser,
  }));

  useEffect(() => {
    moment.relativeTimeThreshold("ss", -1);
    moment.locale("en", {
      relativeTime: {
        past: "%s ago",
        s: "%ds",
        ss: "%ds",
        m: "%dm",
        mm: "%dm",
        h: "%dh",
        hh: "%dh",
        d: "%dd",
        dd: "%dd",
        M: "%dM",
        MM: "%dM",
        y: "%dy",
        yy: "%dy",
      },
    });
  }, []);

  useEffect(() => {
    if (props.data.targetType && props.data.targetType === "REQUIRED_READING") {
      axios.get(`/requiredreading/${props.data.targetId}`, { withCredentials:true }).then((res) => {
        setRequiredReading(res.data);
      });
    }
    if(read === null && props.data){
      setRead(props.data.isViewed)
    }

  }, []);

  const wrappedIcon = (icon) => {
    let wrapped = <Avatar>{icon}</Avatar>;
    if (!read) {
      return (
        <Badge
          color="secondary"
          overlap="circle"
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          variant="dot"
        >
          {wrapped}
        </Badge>
      );
    }
    return wrapped;
  };

  const getIcon = () => {
    if (props.data.targetType && props.data.targetType === "REQUIRED_READING") {
      return getRequiredReadingIcon();
    }
    if (read) {
      if (props.data.targetType && props.data.targetType === "MESSAGE") {
        return wrappedIcon(<MailOutlineIcon />);
      } else {
        return wrappedIcon(<NotificationsNoneIcon />);
      }
    } else {
      if (props.data.targetType && props.data.targetType === "MESSAGE") {
        return wrappedIcon(<MailIcon />);
      }
      return wrappedIcon(<NotificationsIcon />);
    }
  };

  const getRequiredReadingIcon = () => {
    if (requiredReading) {
      let readDocuments = 0;
      let totalDocuments = requiredReading.requiredReadingDocuments.length;
      requiredReading.requiredReadingDocuments.forEach((element) => {
        if (element.read) {
          readDocuments++;
        }
      });
      let isCompleted =
        requiredReading.percentCompleted === 100 ||
        readDocuments === totalDocuments;
      return (
        <Tooltip
          classes={{ popper: classes.tooltip }}
          title={
            isCompleted
              ? t("required_reading_task_complete")
              : t("required_reading_num_documents_read", {
                  readDocuments,
                  totalDocuments,
                })
          }
        >
          <ListItemAvatar>
            {isCompleted ? (
              <Avatar>
                <DoneIcon />
              </Avatar>
            ) : (
              <div style={{ width: 40 }}>
                <CircularProgressbar
                  value={readDocuments / totalDocuments}
                  maxValue={1}
                  text={`${readDocuments} / ${totalDocuments}`}
                  styles={buildStyles({
                    textSize: "35px",
                    pathColor: theme.palette.primary.main,
                    textColor: theme.palette.primary.main,
                  })}
                />
              </div>
            )}
          </ListItemAvatar>
        </Tooltip>
      );
    } else {
      return (
        <Skeleton animation="wave" variant="circle" width={40} height={40} />
      );
    }
  };

  const getSecondaryText = () => {
    if (props.data.targetType) {
      if (props.data.targetType === "REQUIRED_READING") {
        return t("global_required_reading");
      } else if (props.data.targetType === "SYSTEM") {
        return t("system_notification");
      } else if (props.data.targetType === "MESSAGE") {
        return t("notification_message_click_to_read");
      }
      return t("notification_click_to_view");
    }
  };

  const onClick = () => {
    if (props.data.targetType) {
      switch (props.data.targetType) {
        case "MESSAGE":
          setCollapseOpen(!collapseOpen);
          markRead();
          break;
        case "REVISION":
          markRead();
          onClose();
          history.push(`/full/document/${props.data.targetId}`);
          break;
        case "DOCUMENT":
          markRead();
          onClose();
          history.push(`/full/document/${props.data.targetId}`);
          break;
        case "REQUIRED_READING":
          setDialogOpen(true);
          break;
        case "JOB":
          markRead();
          onClose();
          history.push(`/full/managejobs`);
          break;
        case "KNOWLEDGE_SOURCE":
          markRead();
          onClose();
          history.push(`/full/manageks`);
          break;
        case "DISCUSSION":
          markRead();
          onClose();
          discussionClient
            .get(`/discussion/${props.data.targetId}`)
            .then((res) => {
              switch (res.data.type) {
                case "TAXONOMY_NODE":
                case "TOPIC":
                  let type = res.data.type === "TOPIC" ? "topic" : "taxonomy;";
                  history.push(
                    `/full/taxonomydiscussions/${type}/${
                      res.data.itemId
                    }/discussion/${res.data.discussionId}`
                  );
                  break;
                case "DOCUMENT":
                  history.push(`/full/document/${res.data.itemId}`, {
                    state: {
                      discussionId: res.data.discussionId,
                    },
                  });
                  break;
                case "KNOWLEDGE_ITEM":
                  history.push(`/full/knowledgeitem/${res.data.itemId}`, {
                    state: {
                      discussionId: res.data.discussionId,
                    },
                  });
                  break;
                case null:
                  history.push(`/full/discussion/${res.data.discussionId}`, {
                    state: {
                      discussionId: res.data.discussionId,
                    },
                  });
              }
            });
          break;
      }
      // break;
    }
  };

  const markRead = () => {
    
    stompClientsContainer.notificationservice.publish({
      destination: "/app/notification/read",
      body: JSON.stringify({ messageId: props.data.messageId }),
    });
    setRead(true);
  };

  // const getNotification = () => {
  //   notificationClient
  //     .get("/notification/"+props.data.messageId, { withCredentials: true })
  //     .then((res) => {
  //       setContent(res.data.content);
  //       markRead();
  //     });
  // };

  const isButton = () => {
    if (
      (props.data.targetType && props.data.targetType === "MESSAGE") ||
      (props.data.targetType && props.data.targetId)
    ) {
      return true;
    }
  };

  const dismissNotification = () => {
    stompClientsContainer.notificationservice.publish({
      destination: "/app/notification/delete",
      body: JSON.stringify({ messageId: props.data.messageId }),
    });
  };

  const onDocumentClick = (doc) => {
    onClose();
    history.push(`/full/document/${doc.documentID}`);
  };

  const onClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  return (
    <>
      <ListItem
        onClick={onClick}
        button={isButton()}
        dense
        disableGutters
        ContainerComponent="div"
        // aria-label={getAriaLabel()}
      >
        <ListItemAvatar>{getIcon()}</ListItemAvatar>
        <ListItemText
          primary={t(props.data.title)}
          secondary={getSecondaryText()}
          style={{ marginRight: 15, overflowWrap: "anywhere" }}
        />
        <ListItemSecondaryAction>
          <div style={{ display: "flex", flexDirection: "row" }}>
            {requiredReading &&
              Date.parse(requiredReading.expiry) < Date.now() && (
                <Tooltip
                  title={"Expired"}
                  classes={{ popper: classes.tooltip }}
                >
                  <ErrorOutlineIcon
                    fontSize="large"
                    style={{ marginRight: 2, color: red[600] }}
                  />
                </Tooltip>
              )}
            <div className={classes.actionContainer}>
              <span className={classes.timeAgo}>
                {moment(props.data.createdDate).fromNow()}
              </span>
              <Tooltip
                title={t("notification_dismiss")}
                classes={{ popper: classes.tooltip }}
              >
                <IconButton
                  edge="end"
                  size="small"
                  className={classes.dismissIcon}
                  onClick={dismissNotification}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </ListItemSecondaryAction>
      </ListItem>
      <Collapse in={collapseOpen} timeout="auto">
        <div style={{ margin: 5, display:'flex' }}>
          {props.data.content && ( 
            <KpsEditor initialContent={props.data.content} readOnly />
          )}
           {currentUser.userPermits.roles.hotTopicer && (
            <IconButton
              onClick={() => setEditMessage(!editMessage)}
              aria-label="Edit Message"
            >
              <EditIcon fontSize="small" />
            </IconButton>
          )}
        </div>
      </Collapse>
      {props.data.targetType &&
        props.data.targetType === "MESSAGE" && (
          <CreateMessage
            isEdit
            hotTopic={props.data}
            open={editMessage}
            onClose={() => setEditMessage(!editMessage)}
          />
        )}

      {requiredReading && (
        <Dialog
          open={dialogOpen}
          aria-labelledby="req-reading-dialog-title"
          aria-describedby="req-reading-dialog-body"
          onClose={() => {
            setDialogOpen(false);
            markRead();
          }}
        >
          <DialogTitle id="req-reading-dialog-title">
            {requiredReading.title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="req-reading-dialog-body">
              {requiredReading.description}
            </DialogContentText>
            <List>
              {requiredReading.requiredReadingDocuments.map((ele, idx) => {
                return (
                  <div key={idx} role="listitem">
                    <ListItem
                      autoFocus={idx === 0}
                      button
                      onClick={() => {
                        onDocumentClick(ele);
                        markRead();
                      }}
                    >
                      <ListItemText
                        primary={ele.userTitle}
                        secondary={
                          ele.read ? (
                            <span style={{ display: "flex" }}>
                              <DoneIcon />
                              <Typography>
                                {t("required_reading_read_on", {
                                  date: moment(ele.dateRead).format(
                                    "DD/MM/YYYY HH:mm"
                                  ),
                                  interpolation: { escapeValue: false },
                                })}
                              </Typography>
                            </span>
                          ) : (
                            t("required_reading_unread")
                          )
                        }
                      />
                    </ListItem>
                    <Divider />
                  </div>
                );
              })}
            </List>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setDialogOpen(false);
                markRead();
              }}
              color="primary"
            >
              {t("global_close")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}

export default ItemNotification;
